import styled from '@emotion/styled'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import TableCell from '~/components/table/TableCell'

export const ActionsTableCell = styled(TableCell)`
  width: 0px; /** necessary to get the last cell to shrink down to hug action buttons */
`

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
`

export const FilterAction = styled.form`
  margin: 12px 0px;
  display: flex;
`

/** The muted em dash a cell shows for a value that is not there. One place, so every column draws the same nothing. */
export const AbsentValue = styled.span`
  color: ${Colors.Ash};
`

export const NoResultsTableCell = styled(TableCell)`
  ${Fonts.colors.SlateGrey}
  font-style: italic;
`

//---------------------------------------------
// Other table style we use when selecting rows
//---------------------------------------------
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`

export const Th = styled.th`
  border-top: none;
  border-bottom: 1px solid ${Colors.Platinum};
  padding: 0.5rem;
  text-align: left;
  font-weight: 500;
`

export const ThInfo = styled.span`
  ${Fonts.P3}
  color: ${Colors.SlateGrey};
  font-style: italic;
  font-weight: 500;
  margin-left: 0.5rem;
`

export const Td = styled.td`
  border-top: 1px solid ${Colors.Platinum};
  border-bottom: 1px solid ${Colors.Platinum};
  border-left: none;
  border-right: none;
  padding: 0.25rem 0.5rem;
  height: 38px;
  cursor: pointer;
`

export const NoResultsTd = styled(Td)`
  ${Fonts.colors.SlateGrey}
  font-style: italic;
  cursor: default;
  border-bottom: none;
`

export const CheckboxTh = styled.th`
  width: 20px;
  border-top: none;
  border-bottom: 1px solid ${Colors.Platinum};

  .mantine-Checkbox-root {
    height: 100%;
    display: flex;
  }
`

export const CheckboxTd = styled.td`
  width: 20px;
  border-top: 1px solid ${Colors.Platinum};
  border-bottom: 1px solid ${Colors.Platinum};
  border-left: none;
  border-right: none;

  .mantine-Checkbox-root {
    height: 100%;
    display: flex;
  }
`
//---------------------------------------------
